import { type UseMutationOptions, type UseMutationResult, useMutation } from '@tanstack/react-query';

import { useQueryStateAppContext } from '@/packages/query-state/shared/context/appContext';

import {
  type TAddFavoriteRequest,
  type TAddFavoriteResponse_1,
} from '@/repositories/generated/shared/favorites/v1/add-favorite';

import { type QueryError, getQueryKey } from './internal/config';
import { fetchAddFavoriteService } from './internal/fetchService';

type AddFavoriteParameters = TAddFavoriteRequest;

export function useAddFavoriteMutation<TContext = unknown>(
  options?: Omit<
    UseMutationOptions<TAddFavoriteResponse_1, QueryError, AddFavoriteParameters, TContext>,
    'mutationKey' | 'mutationFn'
  >,
): UseMutationResult<TAddFavoriteResponse_1, QueryError, AddFavoriteParameters, TContext> {
  const context = useQueryStateAppContext();

  return useMutation<TAddFavoriteResponse_1, QueryError, AddFavoriteParameters, TContext>({
    mutationFn: parameters => fetchAddFavoriteService(context, parameters),
    mutationKey: getQueryKey(),
    ...options,
  });
}
